import { createFileRoute } from '@tanstack/react-router'
import { PoolPage } from '@/features/trade/pool/PoolPage'

export const Route = createFileRoute('/_app/pool/')({
  component: PoolPage,
})
